import { render, staticRenderFns } from "./OrgChartPersonCard.vue?vue&type=template&id=605c751c&scoped=true&"
import script from "./OrgChartPersonCard.vue?vue&type=script&lang=js&"
export * from "./OrgChartPersonCard.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartPersonCard.vue?vue&type=style&index=0&id=605c751c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c751c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
